import { useEffect } from "react";

const ensureArray = (data) => {
  if (!data) return [];
  return Array.isArray(data) ? data.filter(Boolean) : [data];
};

export default function StructuredData({ data }) {
  useEffect(() => {
    const entries = ensureArray(data);
    if (entries.length === 0 || typeof document === "undefined") {
      return () => {};
    }

    const scripts = entries.map((entry, index) => {
      const script = document.createElement("script");
      script.type = "application/ld+json";
      script.setAttribute(
        "data-structured-data",
        `structured-data-${index}-${Math.random().toString(36).slice(2)}`
      );
      script.text = JSON.stringify(entry);
      document.head.appendChild(script);
      return script;
    });

    return () => {
      scripts.forEach((script) => {
        if (script.parentNode) {
          script.parentNode.removeChild(script);
        }
      });
    };
  }, [data]);

  return null;
}
